import { createSlice, isAnyOf } from "@reduxjs/toolkit";
import { v4 as uuidv4 } from "uuid";
import {
  getReciptVoucher,
  getReciptVoucherById,
  getParticularPage,
  getNext,
  getPrevious,
  handleSearch,
  createReciptVoucher,
  updateReciptVoucher,
  approveReciptVoucher,
} from "./thunk";

const initialState = {
  reciptVouchers: [],
  edit: false,
  reciptVoucher: null,
  count: 0,
  pageNo: 1,
  next: null,
  previous: null,
  loading: false,
  loadingCreate: false,
  loadingUpdated: false,
  loadingReciptVoucher: false,
  loadingNext: false,
  loadingDetails: false,
  saveAndContinue: false,
  loadingApprove: false,
  reciptVoucherDetails: [
    {
      account: null,
      drAmount: "",
      crAmount: "",
      checkNo: "",
      costCenterDetail: "",
      unique: uuidv4(),
    },
  ],
  showCreateModal: false,
};

export const reciptVoucherSlice = createSlice({
  name: "reciptVoucher",
  initialState,
  reducers: {
    setShowCreateModal: (state, action) => {
      state.showCreateModal = action.payload;
    },
    setSaveAndContinue: (state, { payload }) => {
      state.saveAndContinue = payload;
    },
    goToPage: (state, { payload }) => {
      state.pageNo = payload;
    },
    reciptVoucherDetailsUpdated: (state, action) => {
      state.reciptVoucherDetails = action.payload;
    },
    clearReciptVoucherDetails: (state) => {
      state.reciptVoucherDetails = [
        {
          account: null,
          drAmount: "",
          crAmount: "",
          checkNo: "",
          costCenterDetail: "",
          unique: uuidv4(),
        },
      ];
    },
    clearAllReciptVoucher: (state) => {
      state.edit = false;
      state.loading = false;
      state.loadingUpdated = false;
      state.loadingReciptVoucher = false;
      state.reciptVoucher = null;
      state.saveAndContinue = false;
      state.reciptVoucherDetails = [
        {
          account: null,
          drAmount: "",
          crAmount: "",
          checkNo: "",
          costCenterDetail: "",
          unique: uuidv4(),
        },
      ];
    },
  },
  extraReducers: (builder) => {
    builder.addCase(createReciptVoucher.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(createReciptVoucher.fulfilled, (state, action) => {
      state.loading = false;
    });
    builder.addCase(createReciptVoucher.rejected, (state) => {
      state.loading = false;
    });
    builder.addCase(updateReciptVoucher.pending, (state) => {
      state.loadingUpdated = true;
    });
    builder.addCase(updateReciptVoucher.fulfilled, (state, action) => {
      state.loadingUpdated = false;
      state.reciptVoucher = action.payload.data;
      state.reciptVoucherDetails = action.payload.data?.reciptVoucherDetails?.map((value) => {
        return { ...value, unique: uuidv4() };
      });
    });
    builder.addCase(updateReciptVoucher.rejected, (state) => {
      state.loadingUpdated = false;
    });
    builder.addCase(approveReciptVoucher.pending, (state) => {
      state.loadingApprove = true;
    });
    builder.addCase(approveReciptVoucher.fulfilled, (state, action) => {
      state.loadingApprove = false;
      state.reciptVoucher = action.payload.data;
      state.reciptVoucherDetails = action.payload.data?.reciptVoucherDetails?.map((value) => {
        return { ...value, unique: uuidv4() };
      });
    });
    builder.addCase(approveReciptVoucher.rejected, (state) => {
      state.loadingApprove = false;
    });
    // getReciptVoucherById
    builder.addCase(getReciptVoucherById.pending, (state) => {
      state.loading = true;
      state.reciptVoucher = null;
    });
    builder.addCase(getReciptVoucherById.fulfilled, (state, action) => {
      state.edit = true;
      state.loading = false;
      state.reciptVoucher = action.payload.data;
      state.reciptVoucherDetails = action.payload.data?.reciptVoucherDetails?.map((value) => {
        return { ...value, unique: uuidv4() };
      });
    });
    builder.addCase(getReciptVoucherById.rejected, (state) => {
      state.edit = false;
      state.loading = false;
    });
    builder.addMatcher(
      isAnyOf(
        getReciptVoucher.pending,
        getParticularPage.pending,
        getPrevious.pending,
        getNext.pending,
        handleSearch.pending
      ),
      (state) => {
        state.loadingReciptVoucher = true;
      }
    );

    builder.addMatcher(
      isAnyOf(
        getReciptVoucher.fulfilled,
        getParticularPage.fulfilled,
        getPrevious.fulfilled,
        getNext.fulfilled,
        handleSearch.fulfilled
      ),
      (state, action) => {
        state.loadingReciptVoucher = false;
        state.reciptVouchers = action.payload.data;
        state.count = action.payload.totalCount;
        state.previous = action.payload.previous;
        state.next = action.payload.next;
      }
    );
    builder.addMatcher(
      isAnyOf(
        getReciptVoucher.rejected,
        getParticularPage.rejected,
        getPrevious.rejected,
        getNext.rejected,
        handleSearch.rejected
      ),
      (state) => {
        state.loadingReciptVoucher = false;
      }
    );
  },
});

export const {
  setShowCreateModal,
  setSaveAndContinue,
  goToPage,
  reciptVoucherDetailsUpdated,
  clearReciptVoucherDetails,
  clearAllReciptVoucher,
} = reciptVoucherSlice.actions;

export default reciptVoucherSlice.reducer;
